/* Fit the complete mobile heading after font load and on container resizing. */
(() => {
  if (window.fpPdpTitleFitReady) return;
  window.fpPdpTitleFitReady = true;
  const mobile = window.matchMedia('(max-width: 749px)');
  const observed = new WeakSet();
  const widths = new WeakMap();
  const fit = heading => {
    if (!heading) return;
    heading.style.removeProperty('--fp-title-size');
    heading.removeAttribute('data-fp-title-wrap');
    if (!mobile.matches || !heading.clientWidth) return;
    const text = heading.querySelector('span');
    if (!text) return;
    // Pixel minimum protects readability; rem minimum follows user text size.
    const minimum = Math.max(14, 1.4 * parseFloat(getComputedStyle(document.documentElement).fontSize));
    let size = Math.max(minimum, 20);
    heading.style.setProperty('--fp-title-size', `${size}px`);
    const measured = text.getBoundingClientRect().width;
    if (measured > heading.clientWidth) {
      size = Math.max(minimum, Math.floor(size * (heading.clientWidth - 1) / measured * 10) / 10);
      heading.style.setProperty('--fp-title-size', `${size}px`);
    }
    if (text.getBoundingClientRect().width > heading.clientWidth + .5) heading.setAttribute('data-fp-title-wrap','');
  };
  const observer = new ResizeObserver(entries => entries.forEach(entry => {
    const width = entry.contentRect.width;
    if (widths.get(entry.target) === width) return;
    widths.set(entry.target,width);
    fit(entry.target.querySelector('[data-fp-fit-title]'));
  }));
  const init = () => document.querySelectorAll('[data-fp-fit-title]').forEach(heading => {
    const box = heading.parentElement;
    if (!observed.has(box)) { observed.add(box); observer.observe(box); }
    fit(heading);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.fonts.ready.then(init);
  mobile.addEventListener('change',init);
  document.addEventListener('shopify:section:load',init);
})();
